import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment } from 'react';
import { Form } from 'informed';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import { CheckBox } from '../../components';
import defaultClasses from './categoryFilter.module.css';

var CategoryFilterForm = function CategoryFilterForm(_ref) {
  var subCategories = _ref.subCategories,
      handleCheckboxClick = _ref.handleCheckboxClick,
      selectedSubcategories = _ref.selectedSubcategories,
      loggedNotConsumer = _ref.loggedNotConsumer,
      subcategoryVideoTutorials = _ref.subcategoryVideoTutorials;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      customer_flow_map_group = _useUserContext2[0].currentUser.customer_flow_map_group;

  var displayCategories = subCategories === null || subCategories === void 0 ? void 0 : subCategories.map(function (item, index) {
    var hasItemsAllowedByCustomerGroup = item.items.some(function (item) {
      if (item.customer_group) {
        var _item$customer_group;

        return (_item$customer_group = item.customer_group) === null || _item$customer_group === void 0 ? void 0 : _item$customer_group.includes(customer_flow_map_group ? customer_flow_map_group : 'Consumer');
      } else {
        return item;
      }
    });
    return React.createElement(Fragment, {
      key: index
    }, hasItemsAllowedByCustomerGroup ? item.name === subcategoryVideoTutorials ? loggedNotConsumer ? React.createElement(CheckBox, {
      field: "".concat(item === null || item === void 0 ? void 0 : item.name.toLowerCase(), "-").concat(index),
      type: "check",
      onChange: function onChange() {
        return handleCheckboxClick(item);
      },
      fieldValue: selectedSubcategories.includes(item),
      label: item.name,
      classes: {
        root: defaultClasses.filterCheckboxRoot
      }
    }) : null : React.createElement(CheckBox, {
      field: "".concat(item === null || item === void 0 ? void 0 : item.name.toLowerCase(), "-").concat(index),
      type: "check",
      onChange: function onChange() {
        return handleCheckboxClick(item);
      },
      fieldValue: selectedSubcategories.includes(item),
      label: item.name,
      classes: {
        root: defaultClasses.filterCheckboxRoot
      }
    }) : null);
  });
  return React.createElement(Form, null, displayCategories, " ");
};

export default CategoryFilterForm;